
export default {
    data() {
        return {
            cols: ['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'],
            matrix: [],
            lastSync: null,
            loading: false
        }
    },

    computed: {
        // Hitung total gabungan per golongan (A, B, O, AB) dan grand total
        groupTotals() {
            const totals = { A: 0, B: 0, O: 0, AB: 0, Total: 0 }

            // pastikan matrix terisi
            if (!Array.isArray(this.matrix)) return totals

            this.matrix.forEach(row => {
                // ambil nilai tiap rhesus (bisa 0 atau undefined)
                const aPlus = Number(row['A+'] || 0)
                const aMin = Number(row['A-'] || 0)
                const bPlus = Number(row['B+'] || 0)
                const bMin = Number(row['B-'] || 0)
                const oPlus = Number(row['O+'] || 0)
                const oMin = Number(row['O-'] || 0)
                const abPlus = Number(row['AB+'] || 0)
                const abMin = Number(row['AB-'] || 0)
                const rowTotal = Number(row['Total'] || 0)

                totals.A += aPlus + aMin
                totals.B += bPlus + bMin
                totals.O += oPlus + oMin
                totals.AB += abPlus + abMin
                totals.Total += rowTotal
            })

            return totals
        }
    },


    methods: {
        // === AMBIL DATA DARI BACKEND ===
        fetchMatrix: function () {
            this.loading = true
            this.$store.commit("shoWLoading")

            // Buat parameter query
            const query = new URLSearchParams({
                page: 1,
                limit: 10000,
                sort_by: "s.jumlah_stok",
                sort_dir: "DESC"
            }).toString()

            const url = this.$store.state.url.STOK + "view?" + query

            fetch(url, {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }
            })
                .then(res => res.json())
                .then(res_data => {
                    console.log("stok_darah view:", res_data)
                    const rows = Array.isArray(res_data.data)
                        ? res_data.data
                        : (res_data.rows || [])

                    const map = {}

                    rows.forEach(r => {
                        const gol = (r.golongan_darah || '').toString().trim().toUpperCase()
                        const rhes = (r.rhesus || '').toString().trim()
                        const komponen = r.nama_komponen || `Komponen ${r.komponen_id}`
                        const colKey = `${gol}${rhes}`

                        if (!map[komponen]) {
                            map[komponen] = { Komponen: komponen, Total: 0 }
                            this.cols.forEach(c => { map[komponen][c] = 0 })
                        }

                        const jumlah = Number(r.jumlah_stok || 0)
                        if (this.cols.includes(colKey)) map[komponen][colKey] += jumlah
                        map[komponen].Total += jumlah
                    })

                    this.matrix = Object.values(map).sort((a, b) => b.Total - a.Total)
                    this.lastSync = new Date()
                })
                .catch(err => {
                    console.error("fetchMatrix error", err)
                    this.matrix = []
                })
                .finally(() => {
                    this.loading = false
                    this.$store.commit("hideLoading")
                })
        }
        ,

        // === FORMAT ANGKA ===
        formatNumber(n) {
            const v = Number(n)
            return isNaN(v) ? (n ?? '-') : v.toLocaleString('id-ID')
        },

        // === FORMAT TANGGAL ===
        formatDate(dt) {
            if (!dt) return '-'
            const d = new Date(dt)
            if (isNaN(d)) return dt
            return d.toLocaleString('id-ID', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        }
    },

    mounted() {
        this.fetchMatrix()
    }
}
